export class AreaEcmModel {
  public assignment_groups: [];
  public notes: string;
}
